// components/filterPosts.js
export const filterPosts = () => {
  const row = document.querySelector("[data-post-filter]");
  const results = document.querySelector("[data-posts-results]");

  if (!row || !results) return;

  row.addEventListener("click", async (e) => {
    const link = e.target.closest("a[data-cat]");
    if (!link) return;

    e.preventDefault(); // <- blokuje przeładowanie

    const catId = link.dataset.cat || "0";

    row.querySelectorAll("a.is-active").forEach((a) => a.classList.remove("is-active"));
    link.classList.add("is-active");

    results.classList.add("is-loading");

    try {
      if (!window.themeSettings?.ajaxUrl || !window.themeSettings?.nonce) {
        throw new Error("Brak themeSettings.ajaxUrl / themeSettings.nonce (localize nie działa)");
      }

      const body = new URLSearchParams( );
      body.set("action", "filter_posts");
      body.set("nonce", window.themeSettings.nonce);
      body.set("cat", catId);

      const res = await fetch(window.themeSettings.ajaxUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8" },
        body: body.toString(),
        credentials: "same-origin",
      });

      const json = await res.json();
      if (!json?.success) throw new Error("AJAX failed");

      // UWAGA: u Ciebie w PHP jest data.html
      results.innerHTML = json.data.html;
    } catch (err) {
      console.error(err);
      // jeśli chcesz fallback to normalnego przejścia, odkomentuj:
      // window.location.href = link.href;
    } finally {
      results.classList.remove("is-loading");
    }
  });
};